import request from "@/router/axios";

export const add = (row) => {
  return request({
    url: "/api/produce/electronic-fence/insert",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/produce/electronic-fence/update",
    method: "post",
    data: row,
  });
};

export const getDetail = (id) => {
  return request({
    url: "/api/produce/electronic-fence/select/id",
    method: "get",
    params: { id },
  });
};

export const getList = (params) => {
  return request({
    url: "/api/produce/electronic-fence/select/page",
    method: "get",
    params,
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/produce/electronic-fence/delete/ids",
    method: "get",
    params: { ids },
  });
};

export const getInspectionRoleList = () => {
  return request({
    url: "/api/produce/inspectionrole/select/list",
    method: "get",
    params: {},
  });
};
